"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("../dtos/accommodationPriceHistoryDto");
class AccommodationTypeDto {
}
exports.AccommodationTypeDto = AccommodationTypeDto;
